import React from 'react';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {createStackNavigator, StackHeaderProps} from '@react-navigation/stack';
import {ThemeProvider} from '@rneui/themed';

import BrandHeader from '../components/BrandHeader';
import {AppRoute} from '../models/AppRoute';
import {
  HeaderConfig,
  RootCheckoutFlowParamList,
} from '../models/navigationTypes';
import CheckoutPaymentScreen from '../screens/cart/CheckoutPaymentScreen';
import CheckoutReviewScreen from '../screens/cart/CheckoutReviewScreen';
import CheckoutScreen from '../screens/cart/CheckoutScreen';
import {STORE_NAME_CHECKOUT} from '../screens/constants';
import rewardsTheme from '../theme/rewardsTheme';

import useCommonScreenOptions from './hooks/useCommonScreenOptions';

export const header =
  (config: HeaderConfig) =>
  ({navigation, route}: StackHeaderProps) =>
    (
      <BrandHeader
        navigation={navigation as any}
        route={route}
        config={config}
      />
    );

const Stack = createStackNavigator<RootCheckoutFlowParamList>();

/**
 * Checkout flow that will be released part of the rewards program.
 * A dedicated checkout stack to streamline the checkout flow
 * @returns
 */
const RootCheckoutFlowStackNavigator = () => {
  const commonScreenOptions = useCommonScreenOptions(true);

  return (
    <ThemeProvider theme={rewardsTheme}>
      <GestureHandlerRootView
        style={{flex: 1}}
        testID="gesture-handler-root-view">
        <Stack.Navigator screenOptions={commonScreenOptions}>
          <Stack.Screen
            name={AppRoute.CART_ORDER_CHECKOUT}
            component={CheckoutScreen}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
                source: STORE_NAME_CHECKOUT,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.CART_ORDER_CHECKOUT_REVIEW}
            component={CheckoutReviewScreen}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
                source: STORE_NAME_CHECKOUT,
              }),
            }}
          />
          <Stack.Screen
            name={AppRoute.CART_ORDER_CHECKOUT_PAYMENT}
            component={CheckoutPaymentScreen}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
                source: STORE_NAME_CHECKOUT,
              }),
            }}
          />
        </Stack.Navigator>
      </GestureHandlerRootView>
    </ThemeProvider>
  );
};

export default RootCheckoutFlowStackNavigator;
